import { useState } from 'react';

export enum Tab {
  NewUserReward = 'New User Reward',
  DepositAndTradingVolumeReward = 'Deposit & Trading Volume Reward',
  FeatureExplorationMissions = 'Feature Exploration Missions',
  DailyMission = 'Daily Mission',
}

export const tabs = [
  Tab.NewUserReward,
  Tab.DepositAndTradingVolumeReward,
  Tab.FeatureExplorationMissions,
  Tab.DailyMission,
];

export const useTab = (index: number = 0) => {
  const [currentTab, setCurrentTab] = useState(tabs[index]);

  const isActive = (tab: Tab) => currentTab === tab;

  return { currentTab, setCurrentTab, tabs, isActive };
};
